"use client";

import { useState } from "react";
import { Chat } from "@/components/chat";
import { ParamInputs } from "@/components/param-inputs";
import { PlaybookSelector, type Selection } from "@/components/playbook-selector";
import { usePlaybookParams } from "@/hooks/usePlaybookParams";
import { useSSESession } from "@/hooks/useSSESession";
import { createSessionFromSelection } from "@/lib/api";

export default function TextChatPage() {
  const [isAgent, setIsAgent] = useState(false);
  const { paramNames, paramValues, setParamValues, resetParams, params } = usePlaybookParams();
  const { sessionId, messages, ended, loading, handleSessionStart, handleSend } =
    useSSESession("text2text");

  async function handleStart(selection: Selection) {
    const isAgentSelection = selection.type === "agent_backend";
    setIsAgent(isAgentSelection);
    const res = await createSessionFromSelection(selection, { source: "sandbox:text-chat", params });
    handleSessionStart(res.session_id, isAgentSelection ? "" : res.reply);
  }

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-3 border-b px-4 py-3">
        <h1 className="text-sm font-medium">文字聊天</h1>
        <PlaybookSelector onStart={handleStart} onPlaybookChange={resetParams} disabled={loading} />
        <ParamInputs params={paramNames} values={paramValues} onChange={setParamValues} disabled={loading} />
      </div>
      <div className="flex-1 overflow-hidden">
        {sessionId ? (
          <Chat
            messages={messages}
            ended={ended}
            loading={loading}
            onSend={handleSend}
            sessionId={sessionId}
            enableMarkdown={isAgent}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-muted-foreground">
            请选择话术并开始会话
          </div>
        )}
      </div>
    </div>
  );
}
